import React, { useEffect,useState } from 'react';
import {  Link,useNavigate } from 'react-router-dom';
import Input from '../input';
import Button from '../button';
import MessageDialog from '../messageDialog';
import LoadingOverlay from '../loadingOverlay';
import ConfirmDialog from '../confirmDialog';
import {get, post } from '../../request'
import './styles.scss';

function ModifyContactDialog({ initItem, onConfirm, onCancel,  isShow}) {
    const [isLoading, setIsLoading] = useState(false);
    const [isDisable, setBtnDisable] = useState(true);
    const [isShowConfirmDialog, setConfirmDialog] = useState(false);

    const [item, setInputs] = useState(initItem);
    const [isValid, setIsValid] = useState({
        name: false,
        cellphone: false
    });
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        setInputs(initItem);
        setIsValid({ ...isValid, ["name"]: initItem.name ? true : false });
        setIsValid({ ...isValid, ["cellphone"]: initItem.cellphone ? true : false });

        var allValid = initItem.name && initItem.cellphone;
        setBtnDisable(!allValid);

    }, [ initItem]);

    

    const handleInputChange = (name, value) => {
        setInputs({ ...item, [name]: value });
    };
    const showDialog = () => {
        //setIsVisible(true);
    };

    const hideDialog = () => {
        //setIsVisible(false);
        if (onCancel) {
            onCancel(false);
        }
    };
    const navigate = useNavigate();
    const handleDeleteClick = () => {
        setConfirmDialog(true);
    }
    const confirmDeleteFinish = (data) => {
        if (data) {            
            setConfirmDialog(false);
            post('delianapi/businesscontact/mydelete/'+ item.id).then((response) => {
                setIsLoading(false);
                if (response.statusCode !== 200) {
                    setErrorMessage(response.message);
                    return;
                }
                var item = response.items[0];
                if (onConfirm) {
                    onConfirm(item);
                }
                hideDialog();

            });
        }
    }
    const handleClick = () => {
        //onConfirm();
        setSuccessMessage("");
        setErrorMessage("");
        setIsLoading(true);
        post('delianapi/businesscontact/save', item ).then((response)=> {
            setIsLoading(false);
            if (response.statusCode !== 200) {
                setErrorMessage( response.message);
                return;
            }
            var item = response.items[0];
            if (onConfirm) {
                onConfirm(item);
            }
            hideDialog();

        });
       
    };

    const handleCancel = () => {
        //onCancel();
        if (onCancel) {
            onCancel();
        }
        hideDialog();
    };
    const handleValidInput = (name, isNewValid) => {
        setIsValid({ ...isValid, [name]: isNewValid });
        if (name == "name") {
            var allValid = isNewValid && isValid["cellphone"];
            setBtnDisable(!allValid); 
        }
        if (name == "cellphone") {
            var allValid = isNewValid && isValid["name"];
            setBtnDisable(!allValid);
        }

    }
    return (
        <div className="dialog modifyContact" style={{ display: isShow ? 'flex' : 'none' }}>
            <div className="dialogModel">
                <div className="closeDialog" onClick={() => handleCancel()}></div>
                    
                    <div className="dialogTitle">编辑联系人</div>
                <div className="dialog-content">
                    <div className="dialog-in">收件人信息</div>
                        
                    <Input className="input" placeholder="姓名" value={item.name || ""}
                        name="name" onChange={value => handleInputChange('name', value)}
                        checkRequied={true} onValidInput={handleValidInput} />

                    <Input className="input" placeholder="手机"
                        value={item.cellphone || ""}
                        name="cellphone" onChange={value => handleInputChange('cellphone', value)}
                        checkRequied={true} onValidInput={handleValidInput}                    />

                    <Input className="input" placeholder="固定电话" value={item.telephone || ""}
                        name="telephone" onChange={value => handleInputChange('telephone', value)}
                         onValidInput={handleValidInput} />

                    <Input className="input" placeholder="Email"
                        value={item.email || ""}
                        name="email" onChange={value => handleInputChange('email', value)}
                         onValidInput={handleValidInput} />

                    <Input className="input" placeholder="QQ" value={item.qq || ""}
                        name="qq" onChange={value => handleInputChange('qq', value)}
                         onValidInput={handleValidInput} />

                    <Input className="input" placeholder="微信"
                        value={item.wechat || ""}
                        name="wechat" onChange={value => handleInputChange('wechat', value)}
                        onValidInput={handleValidInput} />
                    <div className="btn-div">
                        {
                            item.id && <Button btnclass="login_btn red_btn" onClick={() => handleDeleteClick()}
                                title="删&nbsp;&nbsp;除 " disabled={isDisable} />
                        }                        
                        <Button btnclass={`login_btn ${isDisable ?'disabled':'' }`}  onClick={() => handleClick()}
                            title="保&nbsp;&nbsp;存" disabled={isDisable} />
                    </div>
                                          
                    </div>
            </div>

            <MessageDialog message={successMessage || errorMessage} onCancel={() => {setSuccessMessage("");
                setErrorMessage("");
            }} />
            <LoadingOverlay isLoading={isLoading} />
            <ConfirmDialog isShowConfirmDialog={isShowConfirmDialog}
                message="确定要删除吗？"
                data={item}
                onConfirm={confirmDeleteFinish}
                onCancel={() => { setConfirmDialog(false) }}
            />
        </div>
    );
};

export default ModifyContactDialog;